import { useEffect, useRef, useState } from "react";

// See docs/websocket_auth.md — browsers can't attach an Authorization
// header to the WS handshake, so the token (admin or member, same ones
// used for the REST API) goes in a query param instead. The WS server
// runs on its own port (default 6001) on the same host as the REST API.
const buildWsUrl = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;
  const apiUrl = new URL(process.env.REACT_APP_API_KEY);
  const wsProtocol = apiUrl.protocol === "https:" ? "wss:" : "ws:";
  const wsPort = process.env.REACT_APP_WS_PORT || "6001";
  return `${wsProtocol}//${apiUrl.hostname}:${wsPort}?token=${token}`;
};

// Tokens expire after 1 hour with no WS-level refresh (see the doc), so a
// dropped connection from an expired token just stays closed until this
// component remounts with a fresh one — there's nothing to auto-retry yet.
export default function useWebSocket(onMessage) {
  const [connected, setConnected] = useState(false);
  const onMessageRef = useRef(onMessage);
  onMessageRef.current = onMessage;

  useEffect(() => {
    const url = buildWsUrl();
    if (!url) return;

    const ws = new WebSocket(url);
    ws.onopen = () => setConnected(true);
    ws.onclose = () => setConnected(false);
    ws.onerror = () => setConnected(false);
    ws.onmessage = (event) => onMessageRef.current?.(event.data);

    return () => ws.close();
  }, []);

  return { connected };
}
